import { VmsLoader, VmsEmptyState } from './VmsListShell';

// Column-driven table shared by every VMS list.
//
//   columns = [{ key, header, render(row), align, nowrap, className }]
//
// `render` is required for anything but a plain string field; `key` doubles as
// the property name when it is omitted. The last column is conventionally the
// action strip, which sets `align: 'right'` and stops click propagation itself.
const VmsTable = ({ columns, rows, loading, empty, onRowClick, rowKey, loaderLabel }) => {
    const align = (col) => (col.align === 'right' ? 'tw-text-right' : 'tw-text-left');

    return (
        <div className="tw-overflow-x-auto">
            <table className="tw-w-full tw-text-xs">
                <thead>
                    <tr className="tw-bg-gray-50 tw-border-b tw-border-gray-100">
                        {columns.map(col => (
                            <th
                                key={col.key}
                                title={col.title}
                                className={`${align(col)} tw-px-4 tw-py-3 tw-font-bold tw-text-gray-700 tw-text-[11px]`}
                            >
                                {col.header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {loading && (
                        <tr><td colSpan={columns.length}><VmsLoader label={loaderLabel} /></td></tr>
                    )}

                    {!loading && rows.length === 0 && (
                        <tr><td colSpan={columns.length}><VmsEmptyState {...empty} /></td></tr>
                    )}

                    {!loading && rows.map((row, i) => (
                        <tr
                            key={rowKey ? rowKey(row) : i}
                            onClick={onRowClick ? () => onRowClick(row) : undefined}
                            className={`tw-border-b tw-border-gray-50 hover:tw-bg-slate-50/50 tw-transition-colors ${onRowClick ? 'tw-cursor-pointer' : ''}`}
                        >
                            {columns.map(col => (
                                <td
                                    key={col.key}
                                    className={`tw-px-4 tw-py-2.5 tw-text-gray-700 ${align(col)} ${col.nowrap ? 'tw-whitespace-nowrap' : ''} ${col.className || ''}`}
                                    // The row navigates, so an action cell must not
                                    // let its clicks bubble into that.
                                    onClick={col.stopPropagation ? (e) => e.stopPropagation() : undefined}
                                >
                                    {col.render ? col.render(row) : (row[col.key] ?? '—')}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default VmsTable;
